import { useState, useEffect } from "react";
import SimpleListbox from "../../../../components/input/SimpleListbox";
import { STUDENT_CR_SCORES } from "../../student/performance/PerformanceReport";
import { studentPerformanceLink } from "./PerformanceReport";
import {
	WriterCrTraitScore,
	CrTraitScore,
	WriterCrTraitScoreKey,
	CrTraitScoreKey,
} from "./ScoresFilteredByCourseViewModel";
import { TraitChartFilter, TraitScoreEChart } from "./TraitScoreChart";

export const crTraits: TraitChartFilter[] = [
	{ value: "totalScore", label: "Holistic", maxValue: 3 },
	{ value: "textualEvidenceScore", label: "Textual Evidence", maxValue: 3 },
	{ value: "contentAccuracyScore", label: "Content Accuracy", maxValue: 3 },
];

export const crOptions = crTraits.map((t) => ({ value: t.value, label: t.label }));

export function CrTraitScoreChart(props: {
	className?: string;
	courseId: number;
	writerData: WriterCrTraitScore[];
	classData: CrTraitScore;
}) {
	const getData = (filter: TraitChartFilter) => {
		const data = props.writerData.map((data) => {
			const value = data[filter.value as WriterCrTraitScoreKey];
			return {
				name: data.writerName,
				value: value != null ? Number(value) : null,
				link: studentPerformanceLink(props.courseId, data.writerId, STUDENT_CR_SCORES),
			};
		});
		return data.find((d) => d.value !== null) ? data : [];
	};

	const getAverage = (filter: TraitChartFilter) => {
		return props.classData[filter.value as CrTraitScoreKey];
	};

	const [selected, setSelected] = useState(crTraits[0]);

	useEffect(() => {
		const trait = crTraits.find((t) => t.value === selected.value) ?? crTraits[0];
		setSelected(trait);
	}, [selected]);

	if (!props.writerData || props.writerData.length == 0) return "";

	return (
		<div className={props.className}>
			<SimpleListbox
				id="viewFilter"
				options={crOptions}
				value={selected.value}
				className="w-1/6"
				onChange={(e) =>
					setSelected(crTraits.find((t) => t.value === e.target.value) ?? crTraits[0])
				}
			/>

			<TraitScoreEChart
				data={getData(selected)}
				dataLabel={selected.label}
				average={getAverage(selected)}
				maxValue={selected.maxValue}
			/>
		</div>
	);
}
